import { render, staticRenderFns } from "./InLineFile.vue?vue&type=template&id=96766df4&"
import script from "./InLineFile.vue?vue&type=script&lang=js&"
export * from "./InLineFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports